<template>
	<section id="selected-video" class="my-4">
		<div class="container-fluid m-0 p-0">
      <div class="row m-0 home-video-container text" :class="videoContainer">
        <div class="col-12 p-0 d-flex flex-column">
          <EmbeddedVideoPlayer
            :isMP4Video="true"
            videoId="HOME_PAGE_VIDEO_001"
            selectedVideoId="HOME_PAGE_VIDEO_001"
            videoSource="https://projectspectrumlearning.io/tsv/Project%20Spectrum%20Services_WhyDoBusinessWithThe%20DIB.mp4"
            videoThumbnail="https://projectspectrumlearning.io/tsv/ProjectSpectrumServices_WhyDoBusinessWithTheDIB_Thumbnail.png"
          />
          <div class="my-3 d-flex flex-column align-items-start justify-content-center flex-lg-row align-items-lg-center justify-content-lg-between flex-xl-row align-items-xl-center justify-content-xl-between">
            <div class="w-auto">
              <p class="text-start m-0 title-text">
                Why Do Business with the DIB
              </p>
            </div>
            <div class="w-auto d-flex flex-row align-items-center svg-images">
              <img
                :src="require('@assetsImages/youtube-brands-1.svg')"
                width="30px"
                height="30px"
                @click="openYoutubeVideo"
              />
              <img
                :src="require('@assetsImages/Share-08.svg')"
                width="20px"
                height="20px"
                @click="toggleVideoCopy"
              />

              <CopyUrlClipboard
                v-if="isDropdownOpen"
                :classes="'share-button-from-left'"
                :urlSource="homePageVideoUrl"
                :copyHandlerComplete="toggleVideoCopy"
              />
            </div>
          </div>
        </div>
        <div class="w-auto">
          <p class="text-start m-0 title-description">
            Entrepreneurship in the Defense Industrial Base (DIB) empowers small businesses to drive innovation, create jobs, and make a real impact on national defense. This video highlights how small companies, not just major contractors, play a vital role across key sectors like manufacturing, R&D, and knowledge-based services. By wearing multiple hats, these entrepreneurs strengthen the industrial base and reflect the core values of independence and resilience.
          </p>
        </div>
      </div>
		</div>
	</section>
</template>

<script>
  import EmbeddedVideoPlayer from './embedded-video-player.vue';
  import CopyUrlClipboard from './copy-url-clipboard.vue';

  export default {
    name: "HomePageVideo",
    data() {
      return {
        isDropdownOpen: false,
        homePageVideoUrl: `${window.location.origin}/#/?root=HomePage`,
      };
    },
    components: {
      EmbeddedVideoPlayer,
      CopyUrlClipboard,
    },
    computed: {
      videoContainer() {
        return (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) 
                ? "video-container-md-lg-xl"
                : "video-container-xs-sm";
      }
    },
    methods: {
      toggleVideoCopy() {
        this.isDropdownOpen = !this.isDropdownOpen;
      },
      openYoutubeVideo() {
        window.open('https://www.youtube.com/watch?v=IuEn9a0-rJ0', '_blank');
      }
    },
  }
</script>

<style scoped>
  .home-video-container {
    min-width: 340px;
    position: relative;
  }
  .video-container-md-lg-xl {
    margin: auto 30% !important;
  }
  .video-container-xs-sm {
    padding: 20px;
  }
  .svg-images {
    gap: 15px;
  }
  .text {
    color: #000;
    font-family: Rajdhani;
    font-style: normal;
  }
  .title-text {
    font-size: clamp(16px, 2vw, 32px);
    font-weight: 700;
    line-height: 20px;
  }
  .title-description {
    font-size: 20px;
    font-weight: 400;
    line-height: normal;
  }
  .share-button-from-left {
    right: -125px;
    bottom: 15px;
  }
  img:hover {
    cursor: pointer;
  }
</style>